import { Runtime, pipe } from "fp";

import * as Data from "~/Data";
import * as Driver from "~/Driver";
import { Time } from "~/Time";

import * as Event from ".";

export const runtime = () =>
  Runtime.intersection([
    Driver.Status.Response.runtime(),
    Runtime.strict({
      distance: Runtime.number(),
      duration: Time.Duration.Response.runtime(),
      location: Runtime.nullable(Runtime.string()),
      start_location: Runtime.nullable(Runtime.string()),
      original_source: Runtime.nullable(Event.Source.Type.runtime()),
      source: Event.Source.Type.runtime(),
      start_time: Time.DateTime.Response.runtime(),
      notes: Runtime.nullable(Runtime.string()),
      annotation_type: Runtime.string(),
      asset_association_source_type: Runtime.nullable(Runtime.string()),
      asset_id: Runtime.nullable(Runtime.number()),
      asset_custom_name: Runtime.nullable(Runtime.string()),
    }),
  ]);

export const decode = (driver: Data.Reference.Reference) => (
  response: Runtime.ToType<typeof runtime>
): Event.Event =>
  pipe(
    {
      driver,

      location: response.location ?? response.start_location ?? undefined,
      distance: response.distance,
      status: Driver.Status.Response.decode(response),
      notes: response.notes ?? undefined,

      interval: {
        start: response.start_time,
        stop: {
          dateTime: response.start_time.dateTime + response.duration.duration,
        },
      },

      asset: response.asset_id && {
        id: `${response.asset_id}`,
        name: response.asset_custom_name ?? undefined,
      },
    },

    (event) => ({
      ...event,
      sources: {
        current: {
          type: response.source,
          asset: event.asset ? event.asset : undefined,
        },

        original: response.original_source
          ? { type: response.original_source }
          : undefined,
      },
    })
  );
